export enum OrderStatuses {
  DRAFT = 'draft',
  IN_PROGRESS = 'in_progress',
  ERROR = 'error',
  CANCELED = 'canceled',
  COMPLETED = 'completed',
  EXPIRED = 'expired',
  CRITICAL = 'critical',
  CHECKOUT = 'checkout',
  PAID = 'paid',
  REFUNDED = 'refunded',
  PENDING_REFUND = 'pending_refund',
  PENDING = 'pending',
  DATA_ENTRY = 'data_entry',
  INSPECTION = 'inspection',
  OFFER_READY = 'offer_ready',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  PARTIAL_PAID = 'partial_paid',
  OVERDUE = 'overdue',
  TERMINATED = 'terminated',
  SUBMITTED = 'submitted',
  REFUSED = 'refused',
  IN_PROCESSING = 'in_processing'
}
